

export const getCommunityValue = (searchParams: any) => {


  return {
    timeLine: searchParams.get("timeLine") ? searchParams.get("timeLine") : null,
    doc: searchParams.get("doc") ? searchParams.get("doc") : null,
  }
};


